module.exports = __webpack_public_path__ + "images/emoji/heavy_multiplication_x.321103fb90b5e4ecf9f7.png";